"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakeAuth = exports.clearTokens = void 0;
const axios_1 = __importDefault(require("axios"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
const enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
const ui_1 = require("@rahtab/ui");
const helpers_1 = require("./helpers");
let listOfTokens = null;
let sessionToken = null;
let isFetchingNewTokens = false;
let lastToken = '';
const clearTokens = () => {
    listOfTokens = null;
    sessionToken = null;
    lastToken = '';
    isFetchingNewTokens = false;
};
exports.clearTokens = clearTokens;
const useMakeAuth = (config) => {
    const alert = ui_1.useAlert();
    const handleLogout = async () => {
        await helpers_1.removeAuthoriseDataFromStorage();
        config.onAuthenticationFailed && config.onAuthenticationFailed();
        exports.clearTokens();
    };
    const makeAuth = async (useLastToken = false, numberOfRetry = 4) => {
        if (!sessionToken) {
            sessionToken = await async_storage_1.default.getItem('sessionToken');
        }
        let tokensFromStorage;
        if (listOfTokens === null) {
            tokensFromStorage = await async_storage_1.default.getItem('tokens');
            listOfTokens = JSON.parse(tokensFromStorage);
        }
        if (sessionToken === null || tokensFromStorage === null) {
            await handleLogout();
            return;
        }
        let token;
        if (listOfTokens && listOfTokens.length > 0) {
            if (listOfTokens.length < 11 && !isFetchingNewTokens) {
                isFetchingNewTokens = true;
                token = listOfTokens.pop();
                const ticket = encodeURIComponent(hmac_sha256_1.default(token, sessionToken).toString(enc_base64_1.default));
                let authJSON = {
                    eTicket: ticket,
                };
                await helpers_1.setTokensInStorage(listOfTokens);
                let reqAddress = helpers_1.urlBuilder({
                    baseAddress: config.url,
                    callType: 'GetTickets',
                    authJson: JSON.stringify(authJSON),
                });
                try {
                    const res = await axios_1.default.get(reqAddress, { timeout: 4000 });
                    if (res.data === helpers_1.AUTH_FAILED_ERROR) {
                        if (res.data === helpers_1.AUTH_FAILED_ERROR) {
                            const nextNumber = numberOfRetry - 1;
                            if (nextNumber > 0) {
                                isFetchingNewTokens = false;
                                makeAuth(false, nextNumber);
                            }
                            else if (nextNumber === 0) {
                                isFetchingNewTokens = false;
                                await handleLogout();
                            }
                        }
                        isFetchingNewTokens = false;
                        return;
                    }
                    if (!Array.isArray(res.data)) {
                        alert(helpers_1.unhandledErrorGenerator(507));
                        isFetchingNewTokens = false;
                        return;
                    }
                    listOfTokens = [...res.data, ...listOfTokens];
                    await helpers_1.setTokensInStorage(listOfTokens);
                    isFetchingNewTokens = false;
                }
                catch (e) {
                    alert({
                        message: 'اتصال خود را به اینترنت بررسی کنید.',
                        hideBackButton: true,
                        buttons: [
                            {
                                color: 'secondary',
                                text: 'تلاش مجدد',
                                onPress: () => makeAuth(true),
                            },
                        ],
                    });
                }
            }
            if (isFetchingNewTokens) {
                makeAuth(false);
                return;
            }
            if (useLastToken && lastToken) {
                listOfTokens.push(lastToken);
            }
            token = listOfTokens.pop();
            lastToken = token;
            const ticket = encodeURIComponent(hmac_sha256_1.default(token, sessionToken).toString(enc_base64_1.default));
            await helpers_1.setTokensInStorage(listOfTokens);
            let authJSON = {
                eTicket: ticket,
            };
            return JSON.stringify(authJSON);
        }
    };
    return makeAuth;
};
exports.useMakeAuth = useMakeAuth;
